import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PackageCreateWizard from '../../../Components/Voss/Packages/PackageCreateWizard';
import packageUpdateActions from '../../../Actions/Voss/packageUpdateActions';
import targetGroupActions from '../../../Actions/Voss/targetGroupActions';
import commonActions from '../../../Actions/commonActions';
import { useAppDispatch } from '../../../Store/types';
import routes from '../../../Constants/routes';
import type { CreatePackageRequest, RootState } from '../../../Components/Voss/Packages/Packages.types';

const PackageCreateContainer = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const targetGroups = useSelector((state: RootState) => state.TargetGroupsReducer.targetGroups) ?? [];
    const [isSaving, setIsSaving] = useState(false);
    // the disabled button is state, so a second click or Enter landing before the re-render could still create a duplicate package
    const isCreatingRef = useRef(false);

    useEffect(() => {
        void dispatch(targetGroupActions.getTargetGroups());
    }, [dispatch]);

    const create = (model: CreatePackageRequest) => {
        if (isCreatingRef.current) return;
        isCreatingRef.current = true;
        setIsSaving(true);

        void dispatch(packageUpdateActions.createPackage(model))
            .then((created) => {
                if (created?.id === undefined) return;

                dispatch(commonActions.showSuccess(t('packages.packageCreated')));
                void navigate(routes.vossPackageDetail(created.id), { replace: true });
            })
            .finally(() => {
                isCreatingRef.current = false;
                setIsSaving(false);
            });
    };

    return (
        <>
            <div className="mb-16">
                <Link to={routes.vossPackages}>← {t('packages.title')}</Link>
                <span className="text-secondary mx-8">›</span>
                <span className="text-secondary">{t('packages.createPackage')}</span>
            </div>
            <h1 className="mb-8">{t('packages.createPackageTitle')}</h1>
            <p className="text-secondary mb-24">{t('packages.createPackageSubtitle')}</p>
            <PackageCreateWizard targetGroupOptions={targetGroups} isSaving={isSaving} onCancel={() => void navigate(routes.vossPackages)} onCreate={create} />
        </>
    );
};

export default PackageCreateContainer;
